module.exports = __webpack_public_path__ + "static/media/download4.d5368a06.png";